import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { TermsService } from 'src/app/services/terms';
import { Modal } from 'src/app/components/modal/Modal';
import { GTMService } from 'src/app/services/gtm.service';

@Component({
  selector: 'voucher-details-modal',
  styleUrls: ['./voucher-details-modal.component.scss'],
  templateUrl: './voucher-details-modal.component.html',
  providers: [TermsService],
  encapsulation: ViewEncapsulation.None
})
export class VoucherDetailsModalComponent {

  @ViewChild('modalRef')
  modalRef: Modal;

  @Input()
  voucher: any;

  copied = false;

  constructor(
    private gtm: GTMService,
  ) { }

  open() { this.modalRef.open(); }

  close() { this.modalRef.close(); }

  onCopy() {
    this.copied = true;

    this.gtm.interaction('allya:mgm', 'mgm:meus-vouchers:click', 'copiar-cupom');

    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }
}
